import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  Form,
  Field,
  reduxForm,
} from 'redux-form';
import {
  Card, CardBody, Row, Col, Container, Badge, Label,
} from 'reactstrap';
import TextBox from '../../../../shared/components/form/TextBox';
import renderCheckBoxField from '../../../../shared/components/form/CheckBox';
import renderSelectField from '../../../../shared/components/form/Select';
import LoadingSpinner from '../../../../shared/components/LoadingSpinner';
import setPropsAsInitialValues from '../../../../helpers/setPropsAsInitialValues';
import validate from './validateMoveSection';

class MoveSectionForm extends PureComponent {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    onBack: PropTypes.func.isRequired,
    onStudentEnrollmentChanges: PropTypes.func.isRequired,
    onCheckAllChanges: PropTypes.func.isRequired,
    handleFilterChangeText: PropTypes.func.isRequired,
    onChangeSelect: PropTypes.func.isRequired,
    submitting: PropTypes.bool,
    loading: PropTypes.bool,
    alumnoObj: PropTypes.shape({}),
    students: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    sections: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    filterValue: PropTypes.string,
    checkAll: PropTypes.bool,
  }

  static defaultProps = {
    submitting: false,
    loading: false,
    alumnoObj: {},
    filterValue: '*',
    checkAll: false,
  }

  customStyles = () => ({
    container: base => ({
      ...base,
      width: '400px', // Cambia el ancho aqu� seg�n necesites
    }),
    control: base => ({
      ...base,
      minWidth: '400px', // Asegura que el control tambi�n tenga el ancho adecuado
    }),
  });

  groupBy = (xs, key) => xs.reduce((obj, x) => {
    const rv = obj;
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});


  getShowQuantities = () => (
    [{
      value: 1,
      description: 'Cantidad',
      checked: true,
    }]
  );

  getYears = (students) => {
    const datas = Object.entries(this.groupBy(students, 'year')).map(([year, data]) => ({ year, count: data.length }));

    return (
      <Col md={12} lg={12}>
        <div className="card__title" style={{ marginBottom: '0px' }}>
          <h5 className="bold-text" style={{ fontSize: 17, marginTop: '0.4rem' }}>
            A&#241;os:
            {datas.map(data => (
              <>
                {data.year}:
                <Badge
                  style={{ fontSize: 15 }}
                  color="info"
                  pill
                >
                  {data.count}
                </Badge>
                {',   '}
              </>
            ))}
          </h5>
        </div>
      </Col>
    );
  };

  render() {
    const {
      submitting,
      handleSubmit,
      loading,
      onStudentEnrollmentChanges,
      onCheckAllChanges,
      handleFilterChangeText,
      onChangeSelect,
      onBack,
      students = [],
      sections = [],
      filterValue,
      checkAll,
    } = this.props;

    return (
      <Col md={12} lg={12}>
        <Card>
          <CardBody>
            <div className="card__title">
              <button
                type="submit"
                className="btn btn-primary"
                disabled={submitting}
                onClick={handleSubmit}
              >Guardar
              </button>
              <button
                type="submit"
                className="btn btn-outline-secondary"
                onClick={onBack}
              >Cancelar - Volver
              </button>
            </div>
            {(
              <>
                <Col md={12} lg={12}>
                  <div className="card__title" style={{ marginBottom: '0px' }}>
                    <h5 className="bold-text" style={{ fontSize: 17 }}>
                      Todos:
                      <Badge
                        style={{ fontSize: 18 }}
                        color="primary"
                        pill
                      >
                        {students.length}
                      </Badge>
                      {'  '}
                      Seleccionado:
                      <Badge
                        style={{ fontSize: 18 }}
                        color="success"
                        pill
                      >
                        {students.filter(a => a.selected).length}
                      </Badge>
                      {'  '}
                      No Seleccionado:
                      <Badge
                        style={{ fontSize: 18 }}
                        color="secondary"
                        pill
                      >
                        {students.filter(a => !a.selected).length}
                      </Badge>
                    </h5>
                  </div>
                </Col>
              </>
            )}
            {this.getYears(students)}
            <Row dir="ltr">
              <Col md={12} xl={12} sm={12}>
                <div
                  className="summary-card__item fs-16 form"
                  style={{
                    fontSize: 17,
                    display: 'flex',
                    fontWeight: 'bold',
                  }}
                >
                  <Label
                    style={{ paddingTop: 0, paddingBottom: 0 }}
                    for="filterValue"
                    sm={3}
                    className="form__form-group-label text-right"
                  >
                    Filtrar alumnos:
                  </Label>
                  <Col sm={9}>
                    <div className="form__form-group-field">
                      <Field
                        name="filterValue"
                        component={TextBox}
                        placeholder="Texto a buscar"
                        autoComplete="false"
                        type="text"
                        onChange={handleFilterChangeText}
                        maxLength={32}
                        defaultValue={filterValue}
                      />
                    </div>
                  </Col>
                </div>
              </Col>
            </Row>
            {
              loading
                ? <LoadingSpinner />
                : (
                  <Form className="form" onSubmit={handleSubmit}>
                    <Container className="summary-container">
                      <Row>
                        <Col md={7} lx={12}>
                          <div className="form__form-group">
                            <span className="form__form-group-label required">Materia</span>
                            <div className="form__form-group-field">
                              <Field
                                name="section"
                                component={renderSelectField}
                                placeholder="Profesor Auxiliar"
                                autoComplete="false"
                                options={sections}
                                styles={this.customStyles}
                                onChange={
                                  props => onChangeSelect(props)
                                }
                              />
                            </div>
                          </div>
                        </Col>

                      </Row>
                      <Row>
                        <Col md={6} xl={4} sm={12}>
                          <div
                            className="summary-card__item fs-16"
                            style={{
                              fontSize: 15,
                              display: 'flex',
                              marginTop: '10px',
                            }}
                          >
                            <Field
                              name="checkAll"
                              component={renderCheckBoxField}
                              label="Seleccionar Todos"
                              value={checkAll}
                              defaultChecked={checkAll}
                              onChange={v => onCheckAllChanges(v)}
                            />
                          </div>
                        </Col>
                      </Row>
                      <Row dir="ltr" name="editedStudentEnrollments">
                        {students.map(s => (
                          <Col md={6} xl={4} sm={12} key={`col_student_${s.inscriptionId}`}>
                            <div
                              key={`div_student_${s.value}`}
                              className="summary-card__item fs-16"
                              style={{
                                fontSize: 15,
                                display: 'flex',
                                marginTop: '10px',
                              }}
                            >
                              <Field
                                key={`student_${s.inscriptionId}`}
                                name={`student_${s.inscriptionId}`}
                                component={renderCheckBoxField}
                                label={`${s.doc}/${s.year}: ${s.name}`}
                                className={s.selected ? 'checked' : ''}
                                value={s.selected}
                                defaultChecked={s.selected}
                                onChange={v => onStudentEnrollmentChanges(v, s)}
                              />
                            </div>
                          </Col>
                        ))}
                      </Row>
                    </Container>
                  </Form>
                )
            }
          </CardBody>
        </Card>
      </Col>
    );
  }
}

const ReduxAddInscriptionForm = reduxForm({
  form: 'MoveSectionForm',
  validate,
  enableReinitialize: true,
})(MoveSectionForm);

export default setPropsAsInitialValues(ReduxAddInscriptionForm);
